/* eslint-disable import/prefer-default-export */

// tied to current CSS
export const POST_COL_WIDTH = 730; // px
